export default "__VITE_ASSET__P4hfxA6___"